// Lib
import React from 'react';

import PropTypes from 'prop-types';

// Components
import RemoteUserManager from './RemoteUserManager';
import SocketChannelManager from './SocketChannelManager';
import StaleBoardManager from './StaleBoardManager';
import UserActivityManager from './UserActivityManager';
import RefreshStaleBoardManager from './RefreshStaleBoardManager';
import UserActivityHeartbeat from './UserActivityHeartbeat';
import UserContactsTracker from './UserContactsTracker';

class CollaborationManager extends React.Component {
    render() {
        const { children, currentBoardId } = this.props;
        return (
            <>
                <RefreshStaleBoardManager currentBoardId={currentBoardId} />
                <StaleBoardManager currentBoardId={currentBoardId} />
                <SocketChannelManager currentBoardId={currentBoardId} />
                <UserActivityHeartbeat />
                <UserActivityManager currentBoardId={currentBoardId} />
                <RemoteUserManager currentBoardId={currentBoardId} />
                <UserContactsTracker />

                {children}
            </>
        );
    }
}

CollaborationManager.propTypes = {
    children: PropTypes.element.isRequired,
    currentBoardId: PropTypes.string,
};

export default CollaborationManager;
